module.exports = __webpack_public_path__ + "media/images/auth-bg-image-977f469b.jpg";